import { Provider } from 'react-redux';
import { ThemeProvider } from './contexts/ThemeContext';
import { UserProvider } from './contexts/UserContext';
import { LoadingProvider } from './contexts/LoadingContext';
import { ToastProvider } from './contexts/ToastContext';
import { SidebarProvider } from './contexts/SidebarContext';
import { AppRoutes } from './routes';
import { persistor, store } from './store';
import LoadingPanel from './components/Shared/LoadingPanel';
import { useHttpClient } from './hooks/useHttpClient';
import { PersistGate } from 'redux-persist/integration/react';

// Inner component that uses hooks
const AppContent = () => {
  useHttpClient(); // HttpClient'ı loading context ile bağla

  return (
    <>
      <AppRoutes />
      <LoadingPanel />
    </>
  );
};

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider>
        <UserProvider>
          <LoadingProvider>
            <ToastProvider>
              <SidebarProvider>
                <AppContent />
              </SidebarProvider>
            </ToastProvider>
          </LoadingProvider>
        </UserProvider>
      </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
